import { render, staticRenderFns } from "./StockOperationPage.vue?vue&type=template&id=49fc4aec&scoped=true&"
import script from "./StockOperationPage.vue?vue&type=script&lang=js&"
export * from "./StockOperationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fc4aec",
  null
  
)

export default component.exports